export default {
	loginExpired: 'Login expired, please log in again',
	login: 'Login',
	loginAccount: 'Log in to account',
	logout: 'Logout',
	personalInfo: 'Personal Information',
	purchasingPlatformAccount: 'Purchasing Platform Account',
	purchasingWarning: 'Warm reminder: After adding a purchasing platform, you can unlock the function of batch adding to third-party shopping carts. If you change the password of the purchasing platform, please update it synchronously to avoid affecting your use.',
	add: 'Add',
	batchDelete: 'Batch Delete',
	default: 'Default',
	account: 'Account',
	moveUp: '↑Move Up',
	moveDown: '↓Move Down',
	setAsDefault: 'Set as Default',
	edit: 'Edit',
	delete: 'Delete',
	register: 'Register',
	emailPlaceholder: 'Please enter email',
	passwordPlaceholder: 'Please enter password',
	forgotPassword: 'Forgot password',
	loginSuccess: 'Login successful',
	inputError: 'Input error, please check',
	loginToViewCart: 'Log in to view your cart information',
	loginToViewProfile: 'Log in to view personal information',
	home: 'Home',
	productFavorites: 'Product Favorites',
	followedMerchants: 'Followed Merchants',
	browsingHistory: 'Browsing History',
	complaintsFeedback: 'Complaints & Feedback',
	inquiryRecords: 'Inquiry Records',
	welcome: 'Welcome to our website!',
	welcomeToSourcefind: 'Welcome to Sourcefind',
	loginSlogan: 'Enable all overseas users to directly access first-hand goods sources in China',
	username: 'Username',
	password: 'Password',
	confirmPassword: 'Confirm Password',
	email: 'Email',
	email2: 'Email',
	submit: 'Submit',
	confirm: 'Comfirm',
	cancel: 'Cancel',
	language: 'Language',
	search: 'Search',
	searchPlaceholder: 'Please enter the keyword of the product',
	storeSearchPlaceholder: 'In store search',
	searchStorePlaceholder: 'Please enter the merchant keyword',
	storeSearchButton: 'In store search',
	searchByImage: 'Search by image',
	selectPlatforms: 'Select Products Based On The Purchasing Platform',
	bestSellers: 'Best Sellers',
	merchants: 'Merchants',
	join: 'Join Us',
	feeSchedule: 'Fee Schedule',
	memberLevel: 'Member Level',
	annualFee: 'Annual Fee (CNY/Year)',
	dailySearchUpload: 'Daily Search Upload (Items/Day)',
	windowItems: 'Window Items (Items)',
	dailyWindowRefresh: 'Daily Window Refresh (Items/Day)',
	customerServiceHours: 'Dedicated Customer Service (Hours)',
	contactServiceNow: 'Contact Customer Service to Join Now',
	cart: 'Cart',
	cartEmpty: 'Your cart is empty',
	delete: 'Delete',
	totalSKU: 'Total SKU',
	unit: '',
	unitPiece: 'pieces',
	items: 'products',
	viewAll: 'View All',
	viewMoreProducts: 'View more products',
	howItWorks: 'How it Works',
	companyInfo: 'Company Info',
	aboutSourcefind: 'About Sourcefind',
	becomeMerchant: 'Become a Merchant',
	feedbackSuggestions: 'Feedback & Suggestions',
	contactSupport: 'Contact Customer Service',
	legalTerms: 'Legal Terms',
	privacyPolicy: 'Privacy Policy',
	termsOfService: 'Terms of Service',
	cookieStatement: 'Cookie Statement',
	scanToDownload: 'Scan to download',
	downloadAppleStore: 'Download on App Store',
	downloadGooglePlay: 'Get it on Google Play',
	copyright: 'Sourcefind. All rights reserved.',
	app: 'APP',
	discord: 'Discord',
	relay: 'Relay',
	enquiry: 'Enquiry',
	complaint: 'Complaint',
	top: 'Top',
	discordMeetFriends: 'Come and meet friends who also like Chinese products',
	discordScanToFollow: 'Scan to follow',
	discordJoinPlatform: 'Join The Discord Platform',
	newlyAdded: 'Newly Added',
	enquiryTitle: 'Submit Enquiry',
	enquiryTipTitle: 'Friendly reminder:',
	// Product filter translations
	defaultSort: 'Default Sort',
	salesSort: 'Sort by Sales',
	newestSort: 'Sort by Newest',
	allPlatforms: 'All Platforms',
	cnFans: 'CNFans',
	oopbuy: 'Oopbuy',
	mulebuy: 'Mulebuy',
	allChinaBuy: 'AllChinabuy',
	allPrices: 'All Prices',
	allBrands: 'All Brands',
	shippingOption: 'Shipping Option',
	withShipping: 'With Shipping',
	withoutShipping: 'Without Shipping',
	enquiryTipContent: 'After you post a purchase inquiry, we will push the corresponding information to all merchants on the platform based on the type of product you need. Merchants who have the corresponding products in stock will contact you as soon as possible. Please pay attention to the chat messages from the merchants. ',
	enquiryTipAlert: 'If the quantity and price range are not filled in, it is assumed that there is no upper limit!',
	purchaseType: 'Purchase Type',
	selectPlaceholder: 'Please select',
	clothing: 'Clothing',
	bags: 'Bags',
	shoes: 'Shoes',
	contactEmail: 'Contact Email',
	emailPlaceholder: 'Please enter your email',
	urgencyLevel: 'Urgency Level',
	veryUrgent: 'Very Urgent (1 day)',
	urgent: 'Urgent (3 days)',
	normal: 'Normal (7 days)',
	purchaseQuantity: 'Purchase Quantity',
	quantityPlaceholder: 'Please enter quantity',
	priceRange: 'Price Range',
	priceRangePlaceholder: 'Please enter price',
	productDescription: 'Product Description',
	descriptionPlaceholder: 'Please describe the product requirements',
	referenceImages: 'Reference Images',
	uploadSubmitted: 'Image uploaded successfully',
	purchaseTypeRequired: 'Please select purchase type',
	emailRequired: 'Please enter email',
	emailInvalid: 'Please enter a valid email',
	urgencyLevelRequired: 'Please select urgency level',
	descriptionRequired: 'Please enter product description',
	imagesRequired: 'Please upload reference images',
	enquirySubmitted: 'Enquiry submitted successfully!',
	enquiryFailed: 'Enquiry submission failed!',
	formValidationFailed: 'Please complete all required fields',
	imageTypeError: 'Only image files are allowed',
	imageSizeError: 'Image must be less than 2MB',
	complaintTitle: 'Submit Complaint',
	complaintType: 'Complaint Type',
	productRelated: 'Product Related',
	merchantRelated: 'Merchant Related',
	serviceRelated: 'Service Related',
	otherIssues: 'Other Issues',
	complaintTypeRequired: 'Please select complaint type',
	complaintContent: 'Complaint Content',
	complaintContentPlaceholder: 'Please describe the complaint content',
	complaintContentRequired: 'Please enter complaint content',
	attachment: 'Attachment',
	attachmentRequired: 'Please upload attachment',
	complaintSubmitted: 'Complaint submitted successfully!',
	complaintFailed: 'Complaint submission failed!',
	linkCopied: 'Link copied to clipboard!',
	complaintTipContent: "I'm very sorry for the bad experience you encountered. We will handle your complaint within 24 hours. Please refrain from making malicious complaints, otherwise you will be identified and warned by the system. At the same time, we suggest that you first communicate with the merchant to resolve your issue.",
	complaintTipAlert: 'If you wish to file a complaint against a merchant or the merchant associated with a product, please do so on the product page or the merchant page!',
	relateProduct: 'Related products',
	productIntroduction: 'Product description',
	sales: 'Sales',
	goToBuy: 'Go To Buy',
	customerService: 'Customer Service',
	addToCart: 'Add to Cart',
	saveItem: 'Favorites',
	saveItemSuccess: 'Favorites added successfully',
	saveItemFail: 'Favorites addition failed',
	saveItemCancel: 'Favorites cancellation',
	fans: 'Fans',
	sold: 'Sold',
	follow: 'Follow',
	unfollow: 'Unfollow',
	followSuccess: 'Follow successful',
	followFail: 'Follow failed',
	followCancel: 'Follow cancelled',
	enter: 'Enter',
	// Complaint List translations
	pendingReview: 'Pending Review',
	complaintNumber: 'Complaint Number',
	applicationTime: 'Application Time',
	complaintMerchant: 'Complaint Merchant',
	complaintDescription: 'Complaint Description',
	viewApprovalRecords: 'View Approval Records',
	cancelComplaint: 'Cancel Complaint',
	// Enquiry List translations
	enquiryNumber: 'Enquiry Number',
	urgencyLevel: 'Urgency Level',
	remainingTime: 'Remaining Time',
	purchaseType: 'Purchase Type',
	priceRange: 'Price Range',
	purchaseQuantity: 'Purchase Quantity',
	viewQuotes: 'View Quotes',
	revoke: 'Cancel Enquiry',
	inventory: 'inventory',
	selected: 'Selected',
	total: 'Total',
	searchImageTitle: 'Upload image to search',
	uploadImage: 'Upload image',
	againUploadImage: 'Upload the image again',
	searchImageTip: 'If you have a need for recognizing more than 6 images, please use',
	searchImageTip2: 'Large-scale image recognition and search',
	searchImageTip3: 'To search for products',
	// Product search by more image
	serialNumber: 'Serial Number',
	productImage: 'Product Image',
	matchedProducts: 'Matched Products',
	foundSimilarSource: 'Found similar source',
	selectAll: 'Select All',
	selectedItems: 'items selected',
	products: 'products',
	canUploadImages: 'Can upload images',
	allSourceGoods: 'All Source Goods',
	currentSelection: 'Current Selection',
	selectThisSource: 'Select This Source',
	buyChineseProductsEasy: 'Buying Chinese products is easy',
	buyChineseProductsDesc: 'Whether online or offline, buying Chinese products is extremely easy. We provide image search, text search and other ways to find the corresponding products, so you can place an order with one click. Experience our high-quality service, so that you can browse, buy, the whole process without any obstacles, enjoy the convenience.',
	selectFavoritePlatform: 'Select your favorite purchasing platform',
	platformListDesc: 'Provides common purchasing platforms on the market. Whether it is CNfans, oopbuy, Mulebuy or AllChinaBuy, you can buy it with one click.',
	goodsDelivered: 'The goods you like are delivered to your hands',
	afterPurchaseDesc: 'After you complete your purchase, you can wait for the goods to be delivered to your hands.',
	productInfo: 'Product Information',
	productQuantity: 'Product Quantity',
	unitPrice: 'Unit Price',
	totalPrice: 'Total Price',
	merchantCustomerService: 'Merchant Customer Service',
	addSKU: 'Add SKU',
	lookForSimilar: 'Look for similar',
	deleteSPU: 'Delete SPU',
	unavailableProducts: 'Products that cannot be purchased',
	purchasingPlatform: 'Purchasing Platform',
	sellerCount: 'Seller Count',
	expandall: 'Expand all',
	// Registration page translations
	emailVerification: 'Email Verification',
	setPassword: 'Set Password',
	verificationCode: 'Verification Code',
	enterVerificationCode: 'Please enter verification code',
	verificationCodeNote: 'After entering the verification code, an email verification code will be sent to your email. Please check it.',
	emailCode: 'Email Verification Code',
	enterEmailCode: 'Please enter email verification code',
	emailCodeErr: 'Email verification code error',
	seconds: 'seconds',
	sendVerificationCode: 'Send Verification Code',
	country: 'Country',
	selectCountry: 'Please select your country',
	enterPassword: 'Please enter password',
	nextStep: 'Next Step',
	complete: 'Complete',
	cancelRegistration: 'If you cancel registration now, the information will not be saved. Do you still want to cancel?',
	cancelUpdatePassword: 'If you cancel the password modification now, the information will not be saved. Are you still sure you want to cancel?',
	tip: 'Tip',
	verificationCodeSent: 'Verification code has been sent to your email, please check.',
	// Register form validation messages
	enterEmail: 'Please enter email',
	validEmail: 'Please enter a valid email',
	enterVerificationCode: 'Please enter verification code',
	selectCountry: 'Please select your country',
	enterPassword: 'Please enter password',
	passwordMin: 'Password must be at least 6 characters',
	passwordMax: 'Password cannot exceed 18 characters',
	passwordStrength: 'Password must consist of at least two combinations of uppercase letters, lowercase letters, numbers, and special symbols',
	enterConfirmPassword: 'Please enter confirm password',
	passwordMismatch: 'Password mismatch',
	verificationCodeError: 'Verification code input error',
	registerSuccess: 'Registration successful',
	updatePwdSuccess: 'Password changed successfully',
	changePassword: 'Change password',
	emailExist: 'This email already has an account. Please log in directly. If you forget your password, please click on "Forgot Password" on the login page to retrieve it',
	emailNotExist: 'The email does not exist',
	agree: 'Agree to',
	and: 'and',
	userAgreement: 'User Agreement',
	agreeToTermsRequired: 'Please agree to the user agreement and privacy policy',
	passwordErr: 'Incorrect password',
	confirmLogout: 'Are you sure you want to log out?',
	noData: 'No data available',
	noProduct: 'No products available',
	dataLoading: 'Loading data...',
	loadingFinish: 'All data loaded',
	zhSerch: 'Search in Chinese',
	zhSerchTip1: 'We will translate your input into Chinese to provide you with better search results.',
	zhSerchTip2: 'Uncheck to view search results in the current language',
	// Image search translations
	manualSelect: 'Manual Select',
	waitingRecognition: 'Waiting...',
	recognizingSearching: 'Searching...',
	uploadImageSearch: 'Please upload an image to search',
	selectSearchArea: 'Select search area',
	cancelSelect: 'Cancel selection',
	confirmSelect: 'Confirm selection',
	maxUpload: 'You can upload up to {max} images',
	hasUpload: 'You have uploaded {filesToAdd} images, the maximum allowed is {max} images',
	waitingSearchResult: 'Please wait for the search results',
	minUpload: 'Please upload at least 6 images',
	moreImageSearchTip: 'Supports batch upload of multiple image formats, with a maximum of 50 images per batch. It intelligently extracts the main subject of the product and ignores shooting disturbances, ensuring high accuracy in matching similar products.',
	selectSuccess: 'Selection successful',
	deleteNotData: 'Please select the images to delete',
	confirmDelete: 'Are you sure you want to delete the selected {size} images?',
	deleteSuccess: 'Deletion successful',
	deleteOneIMage: 'Are you sure you want to delete this uploaded image? After deletion, this data will be removed from the image search list.',
	loginMessage: 'Your login status has expired, do you want to go to login?',
	gotoLogin: 'Go to login',
	closeLogin: 'Close login',
	descriptionLengthError: 'Your description is too short, please re-describe',
	closeEnquire: 'Are you sure you want to close the purchase? After closing, the information will not be saved.',
	quantityRangeError: 'Only positive integers are supported, with a maximum value of 9999',
	integerError: 'Please enter a positive integer',
	priceRangeError: 'Only positive two-decimal numbers are supported, with a maximum value of 99999.99',
	priceRangeInputError: 'Price range error, please re-enter',
	unrestricted: 'Unlimited',
	negotiable: 'Negotiable',
	within: 'Within',
	rise: 'From',
	day: 'Day',
	hours: 'Hours',
	revokeEnquiry: 'Are you sure you want to cancel the enquiry?',
	revokeSuccess: 'Revoked successfully',
	revokeFail: 'Revocation failed, please try again later',
	revokeContidion: 'Only enquiries in pending and approved status can be revoked',
	searchKeyword: 'Please enter keywords',
	contactHim: 'Contact Him',
	all: 'All',
	closeComplaint: 'If you close the complaint now, the information will not be saved. Do you still want to close?',
	revokeComplaint: 'Are you sure you want to revoke the complaint?',
	platformIntervention: 'Are you sure you want to apply for platform intervention?',
	applyPlatformIntervention: 'Apply for platform intervention',
	notAllowCancelcomplaint: 'Current status does not allow revocation of complaints',
	noPermission: 'No permission to operate this complaint',
	applyPlatformInterventionReason: 'Please enter the reason for applying for platform intervention',
	notApplyPlatformIntervention:'Current status does not allow applying for platform intervention',
	applySuccess: 'Application successful!',
	applyFail: 'Application failed, please try again later',
	waitingPlatformProcess: 'Waiting platform processing',
	waitingPlatformProcess: 'Waiting for platform processing',
	userSubmitComplaint: 'User Submits Complaint',
	storeReply: 'Merchant Reply',
	userReply: 'User Reply',
	userApplyPlatform: 'User Applies for Platform Intervention',
	platformProcess: 'Platform Intervention Processing',
	userCancelComplaint: 'User Cancels Complaint',
	replyContent:'Please enter your reply content',
	replySuccess:'Reply successful!',
	replyFail:'Reply failed!',
	notAllowReply: 'Current status does not allow reply',
	notIntro: 'No product description available',
	sex: 'Gender',
	selectSex: 'Please select gender',
	nickname: 'Nickname',
	inputNickName: 'Please enter nickname',
	changeAvatar: 'Change avatar',
	uploadAvatar: 'Upload avatar',
	uploading:'Uploading...',
	personalDesc: 'Personal Profile',
	inputPersonalDesc: 'Please enter personal profile',
	male: 'Male',
	female: 'Female',
	other: 'Other',
	purchasingPlatform: 'Purchasing platform',
	selectPurchasingPlatform: 'Please select purchasing platform',
	purchasingPlatformAccount: 'Purchasing platform account',
	inputPurchasingPlatformAccount: 'Please enter purchasing platform account',
	purchasingPlatformPassword: 'Purchasing platform password',
	inputPurchasingPlatformPassword: 'Please enter purchasing platform password',
	setAsDefaultPurchasingPlatform: 'Set as default purchasing platform',
	yes: 'Yes',
	no: 'No',
	pleaseSetDefaultPurchasingPlatform: 'Please set default purchasing platform',
	updatePersonalSuccess: 'Update successful',
	updatePersonalFail: 'Update failed',
	addPurchasingSuccess: 'Add successful',
	addPurchasingFail: 'Add failed',
	existPurchasing: 'Account already exists under this purchasing platform',
	updatePurchasingSuccess: 'Update successful',
	updatePurchasingFail: 'Update failed',
	settingSuccess: 'Setting successful',
	selectDeleteData: 'Please select the data to delete',
	deleteTip:'Are you sure you want to delete this data? Once deleted, it will be irretrievable.'
}